/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-computed-properties-in-native-classes, ember/no-get */
import Controller from '@ember/controller';
import { action, computed } from '@ember/object';
import { alias } from '@ember/object/computed';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import GoalState from '@linc-technologies/linced-common/enums/goal-state';
import { optionAlias } from '@linc-technologies/linced-common/utils/options';
import { saveOrDiscard } from '@linc-technologies/linced-common/utils/record-rollback';

export default class SubjectController extends Controller {
  // Services
  @service
  features;

  @service
  options;

  @service
  session;

  @service
  store;

  @service
  toaster;

  GoalState = GoalState;

  @optionAlias('hero:lock:milestones')
  milestonesLocked;

  @alias('features.sidekickEnabled')
  sidekickEnabled;

  @computed('model.{goals.[],states.[]}')
  get currentStates() {
    let states = [];
    let allStates = this.get('model.states');
    this.get('model.goals').forEach((goal) => {
      let state = allStates.find((item) => item.goal_id === goal.id);
      if (state) {
        states.push(state);
      } else {
        states.push({
          goal_id: goal.id,
          awarded: GoalState.NOT_SET,
        });
      }
    });

    return states;
  }

  refreshStates() {}

  @action
  updateState(goal, previousState, grade) {
    let awarded = GoalState.DEVELOPING;

    switch (previousState) {
      case GoalState.DEVELOPING:
        awarded = GoalState.SECURE;
        break;
      case GoalState.SECURE:
        awarded = GoalState.NOT_SET;
        break;
    }

    let stateParams = {
      schoolId: this.get('session.school'),
      assessorId: this.get('session.person'),
      personId: this.get('model.person'),
      goalId: goal,
      awarded,
    };

    if (!isEmpty(grade)) {
      stateParams.grade = grade;
    }
    let newState = this.store.createRecord('goals/state', stateParams);

    saveOrDiscard(newState)
      .then(() => {
        this.get('model.states').update();
      })
      .catch(() => this.toaster.error('Error saving the goal state.'));
  }

  @action
  updateGrades() {
    this.get('model.states').update();
  }
}
